'404':
  goBack: 返回首页
  notFound: 页面未找到
about:
  cloudCommunity:
    description: 通过构建开源、开放的云原生技术生态，探索云原生技术创新，推进云原生技术在中国发展，赋能千行百业数字化转型。
    duty1: 探索和构建云原生产业软件开源生态，促进云原生产业发展
    duty2: 提升本社区的技术易用性和可靠性
    duty3: 促进本社区范围内的开源软件推广、使用、宣传、培训等
    duty4: 其它经基金会授权的范围
    title: 开放原子云社区
  council:
    title: 理事及监事信息
  infoAbout:
    introduction: >-
      开放原子开源基金会是致力于推动全球开源事业发展的非营利机构，于 2020 年 6
      月在北京成立。基金会秉持“共建、共治、共享”的核心理念，定位为以开发者为中心的开源项目孵化平台和科技公益服务机构，旨在系统打造开放协同的开源生态，提升行业协作效率，赋能千行百业。


      基金会致力于运营并孵化一批具有国际影响力的开源项目，目前重点运营的项目包括面向万物互联场景的开源鸿蒙（OpenHarmony）、面向数字基础设施的开源欧拉（openEuler）、桌面操作系统
      openKylin、高性能数据库 OpenTenBase 以及聚焦人形机器人的 OpenLoong
      等，持续构建产业级开源创新根基。基金会为项目提供传播推广、法务协助、资金支持、技术支撑及开放治理等公益服务，促进、保护、推广开源软件的发展与应用，推进开源项目的繁荣和可持续发展。


      基金会业务范围涵盖资金募集、专项资助、宣传推广、教育培训、学术交流、合规支持、开源生态建设、开源基础设施、国际合作等多个方面，以“两会 两行 一赛
      一报告”为抓手，营造良好开源文化氛围，吸引更多伙伴参与开源体系建设，推动我国在全球开源领域的影响力不断提升，助力建设繁荣的开源生态体系。
    title: 关于我们
  organizationStructure:
    department1: 业务发展部
    department10: 开源大赛组委会办公室
    department2: 运营部
    department3: 法务与知识产权部
    department4: 品牌推广部
    department5: 研发部
    department6: 财务部
    department7: 综合部
    department8: 教育培训部
    department9: 行业研究部
    structure1:
      content: 负责审议和修改基金会章程等。理事会设理事长、副理事长和秘书长，从理事中选举产生，理事长是基金会的法定代表人。
      title: 理事会
    structure2:
      content: 中立技术决策机构，负责基金会技术相关决策，项目孵化评审等。
      title: 技术监督委员会(TOC)
    structure3:
      content: 在理事会授权范围内，对开源安全相关的流程、项目、工具、标准、对外合作等工作进行规划和统筹执行。
      title: 开源安全委员会
    structure4:
      content: 秘书处是基金会的执行机构，负责基金会日常运营事务等相关工作，由专职的团队提供法务、营销、社区运营、基础设施建设等支撑工作。下设九个部门：
      title: 秘书处
    title: 组织架构
  securityCommitee:
    description: 开源安全委员会为基金会安全相关工作进行规划和统筹执行，主要为以下职责：
    duty1: 为基金会及孵化项目提供开源安全相关建议
    duty2: 制定基金会开源安全工作计划与预算
    duty3: 制定基金会开源安全总则，包括相关的决策机制和流程
    duty4: 发起基金会需要的开源安全类开源项目、工具和平台
    duty5: 开展开源安全相关的国际合作
    duty6: 制定相应的开源安全标准、发布开源安全相关的白皮书
    duty7: 开展开源安全的教育、推广
    duty8: 理事会授权范围内的其他相关工作
    group:
      title1: 牵头单位：
      title2: 安全标准工作组成果介绍
    member:
      title1: 常务理事单位
      title2: 成员单位
    standing:
      title1: 开源安全委员会常务委员会
  technicalOversightCommitee:
    description: >-
      开放原子开源基金会（以下简称“基金会”）技术监督委员会（Technical Oversight
      Commitee,简称“TOC”）为基金会的开源项目提供技术指导，主要承担以下职责：
    duty1: 为基金会提供全球化的技术视野与指导
    duty2: 审核/批准项目孵化/毕业
    duty3: 制定导师职能，审核，批准导师资源池名单
    duty4: 促进项目间的合作，减少冗余与冲突
    duty5: 接收用户委员会的反馈并协助项目持续完善
    duty6: 促进项目间的生态联系
    duty7: 定义开源相关的常规化实践（原则，流程）
    mentor:
      description: 是技术监督委员会（TOC）指导下的外部专家团队，拥有如下权责利：
      duty1: 辅导基金会的项目孵化，每季度提交项目孵化报告
      duty2: 定期参加辅导项目PMC会议并在项目毕业时给出意见
      duty3: 可得基金会颁发导师证书和基金会官网个人品牌展现
      duty4: 参加基金会各项公开活动并作为演讲嘉宾出席TOC活动
      duty5: 可作为基金会大会的分论坛出品人
      duty6: 可应邀出席TOC内部的线下或者线上会议，发表意见
      duty7: 表现突出导师可个人身份经基金会投票选举成为TOC成员
      more: 查看更多
      position: TOC导师
      title: TOC 导师团
    title: 技术监督委员会(TOC)
  title: 关于我们
certification:
  detail:
    exam:
      label1: 考试地点：
      label2: 联系电话：
      label3: 监考员：
      link: 预约报名
      number: 第 {index} 场
    title1: 认证体系框架
    title2: 认证课程
    title3: 认证流程
    title4: 认证考试预约入口
    title4desc: 关于预约考试的须知或者规则，比如说3 次考试机会前往认证专题页查看详情
    title5: 线下报名入口
    title5desc: 关于预约考试的须知或者规则，比如说3 次考试机会前往认证专题页查看详情
    title6: 线上报名入口
    title6desc: 关于预约考试的须知或者规则，比如说3 次考试机会前往认证专题页查看详情
    title7: 授权培训合作伙伴
  index:
    more: 查看详情
    partner: 授权培训合作伙伴计划
    title: 开源人才认证
cooperation:
  navigator1: 资金捐赠
  navigator2: 项目募集
  navigator3: 合作伙伴
  partner:
    contributor1: 白金捐赠人
    contributor2: 黄金捐赠人
    contributor3: 白银捐赠人
    contributor4: 开源贡献人
    contributorNotice: 注：带*号的捐赠人，捐赠协议正在流程中
    information:
      title: 信息公示
    searchCategoryAll: 全部
    searchInputPlaceholder: 请搜索内容...
    searchInputTitle1: 历史搜索
    searchInputTitle2: 推荐搜索
    tableEmpty: 暂无内容
    tableHead1: 序号
    tableHead2: 捐赠人
    tableHead3: 捐赠对象
    tableHead4: 等级
    title: 合作伙伴
  projectDonate:
    projectStepList:
      desc2: 捐赠方提交项目介绍材料
      desc3: 基金会进行项目介绍材料的审查
      desc4: TOC进行项目孵化评审
      desc5: 对项目代码进行复检
      desc6: 双方签署捐赠协议
      title2: 提交材料
      title3: 材料审查
      title4: 项目评审
      title5: 代码合规检测
      title6: 签署协议
    projectStepTitle: 项目募集流程
    subTitle: 成功进入开放原子开源基金会孵化阶段的开源项目可以获得专业开源服务：
    table:
      category1:
        children:
          sub1:
            children:
              content1: 项目资金资助
            title: 资金资助
          sub2:
            children:
              content1: 项目资金募集
            title: 资金募集
          sub3:
            children:
              content1: 项目资金托管
              content2: 项目财务管理
            title: 资金托管
          sub4:
            children:
              content1: 项目采购服务
            title: 项目采购
          sub5:
            children:
              content1: 项目资金合规审计
            title: 资金审计
        title: 资金服务
      category2:
        children:
          sub1:
            children:
              content1: 项目治理章程模板
              content2: 项目组织架构和角色设置
              content3: 项目协作管理流程模板
              content4: 项目文档管理指引
              content5: 项目贡献规范指引
              content6: 基金会委派执行秘书
              content7: 为工作组提供招聘服务
            title: 项目治理
          sub2:
            children:
              content1: 代码合规分析
              content2: 开源项目合规策略和计划评估
            title: 合规治理
          sub3:
            children:
              content1: 建立社区领导力指引
              content2: 社区用户增长指引
              content3: 社区贡献者激励计划指引
            title: 社区治理
        title: 治理服务
      category3:
        children:
          sub1:
            children:
              content1: 基金会新媒体矩阵品牌露出
              content2: 参与基金会的宣传
            title: 品牌输出
          sub2:
            children:
              content1: 基金会级别大会独立展台
              content2: 基金会级别大会分论坛主办权
              content3: 和基金会联合举办活动
            title: 活动输出
          sub3:
            children:
              content1: 商标设计
              content2: 商标注册
            title: 商标服务
        title: 营销服务
      category4:
        children:
          sub1:
            children:
              content1: 开源许可证管理和风险评估
            title: 开源许可证
          sub2:
            children:
              content1: 开源知识产权管理和风险评估
            title: 开源知识产权
          sub3:
            children:
              content1: 合同审查和专业法律意见
            title: 合同服务
        title: 法律服务
      category5:
        children:
          sub1:
            children:
              content1: 为项目匹配专业的导师
              content2: 提供项目成长的导师计划
              content3: 评估项目的成熟度和健康度
            title: 项目导师
        title: 导师服务
      category6:
        children:
          sub1:
            children:
              content1: 工作坊活动组织指引
              content2: 工作坊活动策划、组织和执行
            title: 工作坊
          sub2:
            children:
              content1: 开发者成长计划指引
              content2: 开发者成长计划策划、组织和执行
            title: 开发者成长计划
        title: 开发者服务
      category7:
        children:
          sub1:
            children:
              content1: 导师认证培训
              content2: 开发者认证培训
            title: 认证培训
        title: 培训服务
      category8:
        children:
          sub1:
            children:
              content1: 基金会大账号使用及维护
            title: 账户管理
          sub2:
            children:
              content1: Git代码托管管理指引
              content2: Git代码托管平台的CLA/DCO
              content3: Git代码托管平台的CI/CD
            title: 代码托管
          sub3:
            children:
              content1: 代码合规扫描
            title: 代码合规
          sub4:
            children:
              content1: 提供官网设计、开发和运维服务
            title: 官网建设
          sub5:
            children:
              content1: 提供论坛、Wiki等IT基础设施的开发
            title: 其他IT设施
        title: IT基础设施的开发
      category9:
        children:
          sub1:
            children:
              content1: 基金会BD支持
              content2: 捐赠单位交流
            title: BD支持
        title: 生态拓展服务
      head1: 服务分类
      head2: 服务子类
      head3: 具体服务内容
    title: 项目募集
  title: 成为光荣的捐赠人
  titleDescription: >-
    作为中国首家开源领域的基金会，为了推进开源项目、开源生态的繁荣发展，希望更多科技企业加入，并与其他捐赠人紧密连接，共同建设开源事业。资源支持、专业服务，近距离体验开源领域最佳实践；吸引共建、加快迭代，构筑企业自身开源战略。变成参与者、成为引领者，定义、维护开源行业前沿技术规范标准。中立运营，公开透明，开源开放，繁荣共创，以开发者为本，共享开源价值！
  titleSmall: 让我们一起，成为开源时代的创造者！
  unSpecialPanel:
    content: >-
      企业、组织或个人可对基金会进行非专项资金捐赠。如捐赠人不限定捐赠资金用于特定活动或项目，捐赠资金将由基金会统筹安排，用于对开源项目基础设施的维护和服务、开放原子商标的保护、以及各种开源赋能计划所需要的支持等符合基金会宗旨的业务。以此推动开源文化的传播，促进开源社区活跃繁荣、保障开源项目可持续发展。
    extraordinaryRule: 不低于人民币 1000 万元/年
    extraordinaryTitle: 杰出捐赠人
    goldRule: 不低于人民币 100 万元/年且承诺连续捐赠不少于 2 年
    goldTitle: 黄金捐赠人
    platinumRule: 不低于人民币 300 万元/年且承诺连续捐赠不少于3年
    platinumTitle: 白金捐赠人
    silverRule: 不低于人民币 20 万元/年
    silverTitle: 白银捐赠人
    title: 非专项捐赠
  welfareDonate:
    contentList:
      desc1: 捐赠方签订保密承诺函
      desc2: 双方签订基金会资金捐赠协议或者基金会项目资金捐赠协议并盖章
      desc3: 捐赠方支付捐赠款项
      desc4: 基金会开具捐赠票据交付捐赠方
      desc5: 基金会对捐赠方品牌进行露出宣传
      title1: 签订承诺函
      title2: 签订协议
      title3: 支付捐款
      title4: 开具捐赠票据
      title5: 品牌宣传
    email: 邮箱：sponsorship{'@'}openatom.org
    specialTabpanel:
      list1: 企业、组织或个人除可对基金会进行非专项资金捐赠外，还可针对基金会的特定活动、项目或计划进行专项资金捐赠。
      list2: 捐赠人在以此种捐赠方式支持社会公益、履行社会责任的同时，还有机会更近距离、更大程度地参与意向的活动、项目或计划。
    telephone: 资金捐赠请联系 电话：010-59258678转8007
    title: 资金捐赠
    welfareTab:
      contentTitle: 资金捐赠流程
      title1: 非专项捐赠
      title2: 专项捐赠
events:
  actionCity: 城市
  actionReset: 重置
  actionSearch: 查询
  actionTitle: 标题
  actionYear: 年度
  info1: 这个月
  info2: 开放原子开源基金会共有{0}场活动
  info3: 在如火如荼地开展中
  info4: 期待在{0}与您相会！
  notFound: 暂无活动
  placeholder1: 请输入
  placeholder2: 全部
  regionAll: 全部
  regionEmpty: 无
  regionNotFound: 未找到
  regionOnline: 线上
  title: 活动概览
footer:
  address: 联系我们：北京市北京经济技术开发区科谷一街8号院8号楼22层2201
  beian: 京ICP备2020036654号-1
  content1: 隐私政策
  content10: 项目募集：
  content11: 法律问题：
  content12: 开放原子开源基金会版权所有
  content13: 京公网安备 11030102011597 号
  content2: 网站使用条款
  content3: 品牌使用指南
  content4: 品牌标识下载
  content5: 媒体合作：
  content6: 反馈与建议：
  content7: 供应商自荐：
  content8: 工作机会：
  content9: 资金捐赠：
  emailError: 邮箱格式不正确
  emailInfo: >-
    订阅后即表示您同意接收来自开放原子开源基金会的有关新闻、活动等内容的电子邮件。您可以随时取消订阅。有关我们的隐私做法和保护您隐私的承诺的信息，请查看我们的隐私政策。我们不会将您的联系信息出售给第三方。
  emailTitle: 订阅开放原子开源基金会，了解最新新闻、活动和更多信息
  info: 信息使用
  information: 开放原子开源基金会是致力于推动全球开源事业发展的非营利机构，于 2020 年 6 月在北京成立。
  nameError: 姓名不能为空
  placegolderEmail: 邮箱
  placegolderName: 姓名
  subscribe: 立即订阅
  subscribeSuccess: 您已成功订阅
header:
  about:
    content1:
      item1:
        desc: 了解我们的历史、业务范围及使命
        title: 简介
      item2:
        desc: 了解我们的结构及工作内容
        title: 组织架构
      item3:
        desc: 了解我们的理事会人员构成
        title: 理事及监事信息
      title: 关于我们
    content2:
      item1:
        desc: 了解我们的委员及导师信息
        title: 技术监督委员会（TOC）
      item2:
        desc: 了解哪些单位为我们提供安全保障工作
        title: 开源安全委员会
      item3:
        desc: 构建开源、开放的云原生技术生态，探索云原生技术创新
        title: 开放原子云社区
      title: ''
  cooperation:
    content1:
      item1:
        desc: 为推进开源项目、开源生态的繁荣发展，望更多科技企业加入，与其他捐赠人共同建设开源事业。
        title: 资金捐赠
      item2:
        desc: 可获品牌提升、资源整合、法律支持等全方位助力，且能维持项目独立性和社区活力。
        title: 项目捐赠
      item3:
        desc: 了解我们有有哪些合作伙伴
        title: 合作伙伴
      title: 合作
    content2:
      item1:
        desc: 了解捐赠的具体流程
        title: 捐赠流程
      item2:
        desc: 了解项目募集流程及所需材料是什么
        title: 项目募集说明
      item3:
        desc: 联系我们了解更多相关内容
        title: 联系我们
      item4:
        desc: ''
        title: 常见问题
      title: 附加信息
  events:
    content1:
      item1:
        title: 开源运营专区
    content2:
      item2:
        title: 2025开放原子开源生态大会
  nav1: 首页
  nav2: 项目
  nav3: 合作
  nav4: 关于
  nav5:
    children:
      nav1: 开放原子校源行
      nav2: 开放原子大赛
      nav3: 开源法律社区
      nav4: 开源态势洞察
      nav5: 开源人才认证
      title1: 公益项目
      title2: 开源活动
    title: 公益活动
  nav6:
    children:
      nav1: 开放原子全球开源峰会
      nav2: 2025开放原子开发者大会
      nav3: 活动概览
    title: 开源活动
  project:
    content1:
      item1:
        title: 孵化期项目
      item2:
        title: 筹备期项目
      item3:
        title: 已归档项目
      item4:
        title: 毕业项目
      title: 全部项目
    content2:
      item1:
        desc: 面向全场景、全连接、全智能时代的智能终端设备操作系统的框架和平台
        title: OpenHarmony
      item2:
        desc: 面向数字基础设施的开源操作系统
        title: openEuler
      item3:
        desc: 人工智能技术深度融合的开源操作系统
        title: openKylin
      item4:
        desc: 分布式数据库核心能力，传统商业数据库兼容能力，同时支持 OLTP/OLAP 能力。
        title: OpenTenBase
      title: 明星项目
  resource:
    item1:
      title: 开放原子校源行
    item2:
      title: 开放原子大赛
    item3:
      title: 开源法律
    item6:
      title: 2025开放原子开发者大会
    item7:
      title: 开源项目服务平台
    title: 资源和工具
home:
  banner:
    button1: 资金捐赠
    button2: 项目捐赠
    button3: 其他合作
    title1: 开放原子大赛
    title2: 开放原子校源行
    title3: ATOMGIT代码仓库
    title4: 2024开放原子开源生态大会
  bottomBanner:
    title: 向您推荐 AtomGit 一起用代码改变世界！
    view: 点击查看
  contributors:
    donationDetails: 查看捐赠详情
    donationOfFundsIntroduce: 为开源事业献出你的一份力量！
    donationOfFundsIntroduce1: 共同发展项目，支持和塑造开源生态系统，鼓励孵化项目产生里程碑式的构建、发布和发展社区
    donationOffunds: 资金捐赠
    more: 查看更多捐赠人
    platinumDonor: 白金捐赠人
    projectDonation: 项目捐赠
    projectDonation1: 欢迎企业、组织或个人捐赠开源项目！
    projectDonation2: 共同发展项目，支持和塑造开源生态系统，鼓励孵化项目产生里程碑式的构建、发布和发展社区
    title: 成为光荣的捐赠人
  event:
    content1:
      description: 软件定义世界，开源共筑未来
  exploreProjects:
    allItems: 所有项目
    desc1: 以下项目按照协议签署时间排序
    incubate: 孵化
    ourProject: 我们的项目
  info:
    numberIntroduce1: |-
      毕业、孵化
      开源项目
    numberIntroduce2: |-
      通过
      TOC评审项目
    numberIntroduce3: 项目代码总量
    numberIntroduce4: 贡献者数量
  infoWills:
    title: 我们的愿景
  information:
    content1:
      button: 资金捐赠
      desc: >-
        诚邀更多科技企业加入开放原子开源基金会捐赠人计划。您的支持将直接赋能开源创新生态，加速前沿技术孵化与普及。作为核心伙伴，您将深度连接顶尖开发者，提升技术影响力与品牌美誉度，共同引领开放协作新时代。开放之约，期待同行！
      title1: 捐赠人
      title2: 成为开源时代的创造者
    content2:
      button: 开始贡献
      desc: >-
        欢迎所有开发者！提交你的首个贡献（PR等），即刻成为项目贡献者。我们诚挚邀请你更进一步：参与议题讨论、协作开发新功能。活跃贡献者将受邀加入核心社群，深度参与项目发展，共同塑造开源未来！
      title1: 贡献者
      title2: 一起建设开源项目
    content3:
      button: 加入社区
      desc: >-
        开源运营专区是基金会面向区域政府、高校、垂直行业与开源企业推出的 SaaS 平台，支持搭建专属开源社区，聚合资源、共建品牌。依托 Git+CMS
        架构与多平台数据汇聚，打通校源行、开源大赛等资源，具备数据洞察、人才评价、本地算力对接等能力。
      title1: 开源社区
      title2: 一起探索开源社区
  more: 了解更多
  openSourceService:
    content: 查看详细服务
    introduce1: 开源战略咨询
    introduce2: 开源法律赋能
    introduce3: 开源项目运营
    introduce4: 开源品牌推广
    title: 开源服务
  services:
    button: 服务申请
    content1:
      desc: 基于 AtomGit 提供的开源社区 SaaS 服务
      tag1: 打造开源品牌
      tag2: 汇多平台数据
      tag3: 连接更多资源
      title: 开源运营专区
    content2:
      desc: AtomGit 是一款高性能的开源协作平台
      tag1: 可靠管理源码
      tag2: 评审机制完善
      tag3: 灵活支持多组织
      title: ATOMGIT
    content3:
      desc: 提供资源申请服务，助力开源生态发展
      tag1: 活动场地支持
      tag2: 活动报名系统支持
      tag3: 演播室支持
      title: 资源申请
    content4:
      desc: 提供开源许可协议选择、代码合规分析、商标全周期管理等法律支持
      tag1: 开源合规咨询
      tag2: 开源许可协议供给
      tag3: 开源法律社区
      title: 法律赋能
    content5:
      desc: 推广开源文化，提升开源项目品牌知名度，助力项目发展
      tag1: 营造开源氛围
      tag2: 打造品牌影响活动
      tag3: 拓展对外品牌合作
      title: 品牌推广
    content6:
      desc: 专业治理，助力开源项目长期发展
      tag1: 社区治理
      tag2: 咨询服务
      tag3: 基础设施
      title: 项目运营
    desc: >-
      提供一站式开源运营解决方案，打通品牌壁垒，汇聚项目数据，高效连接开发者、资源与生态伙伴。提供涵盖资源申请、品牌推广、法律支持与专业项目治理的全方位服务矩阵，赋能开源项目全生命周期，加速创新与成长。
    title: 我们的开源服务
  slogan: 繁荣开源事业 共享开源价值
  welfare:
    content: 查看全部项目
    lawList:
      description1: 通过公开征稿、开放讨论、专家评审的方式，发布公开可用的、可信赖的中文译本。
      description2: 面向律师、企业法务及开发者提供开源合规公益系列课程。
      description3: 搭建开放透明、交流共享的平台，开启开源法律人才交流新纪元。
      name1: “源译识”
      name2: “源规律”
      name3: “心寄源”
      title1: 公益翻译
      title2: 系列课程
      title3: 法律沙龙
    lawTitle: 开源{0}
    lawTitlePrimary: 法律
    title1: 为开源公益
    title2: 献出你的力量
    topic1:
      content: '{0}培育开源人才，提升科技创新企业开源社会责任，加速社会开源创新，促进软件产业高质。'
      contentPrimary: 在全国范围开展开放原子校源行活动将从“源头”宣扬开源文化。
      title: 开放原子{0}
      titlePrimary: 校源行
    topic2:
      content: >-
        开放原子开源大赛旨在联合开源组织、企事业单位、高等院校、科研院所、行业组织、投融资机构等多方资源，充分发挥产业链生态上下游的协同能力，基于开源共享、共建共治的原则共同举办。
      contentPrimary: 开放原子开源基金会发起首届“开放原子全球开源大赛”。
      title: 开放原子{0}
      titlePrimary: 开源大赛
languageName: 简体中文
law:
  database:
    more: 阅读完整内容
    title: 法律资料库
    title2: 法律
    title3: 行政法规
  lectures:
    title1: '"源规律"系列课程'
    title2: 系列课程全面助力开源知识体系形成
  licence:
    title1: 开放原子系列许可证
  salon:
    title1: '"心寄源"法律沙龙'
  translate:
    pepele1:
      name: 周明辉
      title: 教授
    pepele2:
      name: 卫sir
      title: 高工
    pepele3:
      name: 沈芬
      title: 律师
    pepele4:
      name: 宋雷
      title: 教授
    pepele5:
      name: 徐美玲
      title: 助理教授
    title1: “源译识”公益翻译
projects:
  detail:
    number1: Commits 数量
    number2: Star 数量
    number3: Contributor 数量
    number4: Watch 数量
    number5: Fork 数量
    number6: PR 数量
    title1: 下载项目
    title2: 项目代码
    title3: 项目社区
  index:
    briefIntroduction1: 基金会持续构建开源项目发展体系，完善项目战略性布局，孵化培育开源项目
    codeCabin1: 代码仓
    codeCabin2: 代码仓
    details1: 了解详情
    details2: 了解详情
    foundationService: 基金会开源服务
    moreProjects: 查看更多项目
    project1: 开源项目
    project2: 孵化期项目
    project3: 孵化筹备期
    project4: 已归档项目
    project5: 毕业项目
    serviceTabList:
      content:
        comment1: 开源产业趋势分析、技术创新、产业标准、生态发展、高阶创新流程等规划
        comment10: 从开发者、开源项目、开源社区、企业等多维度制定开源治理标准，构建开源软件评估体系
        comment11: 定期举办开发者工作坊、开源技术沙龙&workshop等开源活动，实施开发者激励计划，联动各开源社区多元合作
        comment12: 以代码托管平台AtomGit为核心，提供开源项目运营所需的各项服务和指导
        comment17: 构建官网及全媒体传播渠道
        comment18: 针对开源的技术趋势及项目进展定期营销
        comment19: 从无到有进行开源项目的品牌建设与运营
        comment2: 开源研发流程优化、版本管理设计、代码合规指导、开源安全风险指导及咨询
        comment20: 设计开发与开源文化相关的衍生周边产品
        comment21: 举办开源峰会、开发者大会、开源大赛等活动
        comment22: 组织学校师生参与开源活动，理论和实践相结合
        comment23: 组织策划实施开放原子校源行公益项目，引导学校建开源社团、推广开源文化
        comment24: 甄选校源行开源大使、开源布道师，培养开源导师
        comment25: 制作开源通识课程，组织开源项目贡献开源课程
        comment26: 将基金会的开源项目带入校园共建，培养开源人才
        comment27: 推广开源项目、开源基础理念及开源协作方式
        comment3: 代码许可证兼容、合规建议，代码版权风险
        comment4: 开源组织设计、社区组织设计、高阶流程设计、开闭源设计、技术标准设计
        comment5: 开源许可证合规咨询、开源许可证兼容性分析等
        comment6: 开源治理合规培训、“源规律”开源公益课程等
        comment7: |
          开源合规专业论坛、“心寄源”法律沙龙活动、“源译识”开源翻译等
        comment8: 开源相关案例研究、开源相关许可证拟制、开源相关标准研究等
        comment9: 完成开源项目认证测试，发布开源项目最新版本，协助开源项目孵化毕业
        title1: 开源战略规划
        title10: 开源项目治理体系
        title11: 开源技术主题活动
        title12: 开源基础设施
        title17: 构建全媒体传播渠道
        title18: 针对项目定期营销
        title19: 开源项目品牌建设
        title2: 开源研发管理咨询
        title20: 举办开源相关大型活动
        title21: 打造开源文化矩阵
        title22: 开展开源教育活动和实训
        title23: 在高校培养开源人才后备军
        title24: 激发开源布道志愿者
        title25: 系统构建开源通识教程
        title26: 培养开源学生开发者和贡献者
        title27: 开展开源文化启蒙和培养工作
        title3: 开源项目代码合规指导
        title4: 战略执行设计
        title5: 开源合规法律咨询
        title6: 开源合规法律培训
        title7: 开源法律公益活动
        title8: 开源法律问题研究
        title9: 开源项目管理服务
      title1: 开源战略咨询
      title2: 开源法律赋能
      title3: 开源项目运营
      title4: 开源品牌推广
      title5: 开源教育培训
    title1: 捐赠主体
    title2: 贡献主体
    title3: 项目价值
    title4: 技术特点
    title5: 项目sponsor
    website1: 官网
    website2: 官网
unsubscribe:
  action2: 重新订阅
  desc: 请告诉我们为什么选择取消订阅：
  desc2: >-
    我们很遗憾您决定取消订阅，但我们感谢您一直以来的支持，我们致力于为用户提供优质的内容，但我们也理解您的需求和选择。如果您日后需要，可以随时{0}我们的服务。如果您对取消订阅有任何疑问或需要任何帮助，请通过
    report{'@'}openatom.org 随时联系我们。感谢您的理解和支持!
  desc3: |-
    感谢您订阅我们的最新资讯。您将第一时间收到我们的最新消息，让您更加了解我们的新闻和活动。
    谢谢您的支持！
  placeholder: 请输入原因
  reson1: 我不想再收到这些消息
  reson2: 我从来没有订阅这个邮件列表
  reson3: 邮件内容对我没有帮助
  reson4: 其它
  resubscribe: 订阅成功
  success: 退订成功
  title: 取消订阅
websiteDescription: >-
  作为中国首家开源领域的基金会，为了推进开源项目、开源生态的繁荣发展，希望更多科技企业加入，并与其他捐赠人紧密连接，共同建设开源事业。资源支持、专业服务，近距离体验开源领域最佳实践；吸引共建、加快迭代，构筑企业自身开源战略。
websiteKeywords: >-
  开放原子开源基金会, 全球开源事业, 非营利机构, 阿里巴巴, 百度, 华为, 浪潮, 360, 腾讯, 招商银行, 开源项目, 科技公益, 共建共治共享,
  国际开源社区, 行业协作, 募集资金, 专项资助, 宣传推广, 教育培训, 学术交流, 国际合作, 开源生态建设, 咨询服务, 法务协助, 资金支持,
  技术支撑, 开放治理, 可持续发展
websiteTitle:
  about: 关于我们
  brandGuide: 品牌使用指南
  certification: 开源人才认证
  contact: 联系方式
  cooperation: 合作
  default: 开放原子开源基金会
  events: 活动概览
  insight: 开源态势洞察
  privacyPolicy: 隐私政策
  projects: 开源项目
  terms: 网站使用条款
  unsubscribe: 取消订阅
